import StackdriverErrorReporter from "stackdriver-errors-js";
import asError from "@aglocal/web/helpers/asError";
import normalizeStackFrames from "@aglocal/web/helpers/normalizeStackFrames";
let errorHandler = null;
export function start(config) {
    if (errorHandler) {
        throw new Error("Error reporter already started");
    }
    errorHandler = new StackdriverErrorReporter();
    errorHandler.start(config);
}
export function setUser(user) {
    if (!errorHandler)
        return;
    errorHandler.setUser(user);
}
export async function report(error, options) {
    if (!errorHandler)
        return;
    const err = normalizeStackFrames(asError(error));
    await errorHandler.report(err, options);
}
function noop() {
    // no-op
}
window.reportError = function reportError(error) {
    if (errorHandler) {
        const err = normalizeStackFrames(asError(error));
        errorHandler.report(err).catch(noop);
    }
    else {
        console.error(error);
    }
};
